/* src/app/component/dialogs/gameover-dialog/game-over-dialog.component.scss */
mat-dialog-actions {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=game-over-dialog.component.css.map */
